export default "__VITE_ASSET__0354e384__"